import { Button, Container, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router'

const Homepage = () => {
  const navigate = useNavigate()
  return (
    <div className="homepage-bg">
      <Typography variant="h3" gutterBottom sx={{mt:5, textAlign:'center'}}>
       Photoshop by Vlad Web
      </Typography>
      <div style={{display:'flex', justifyContent:'center'}}>
        <Button onClick={() => navigate('/image-compresser')} variant="outlined" sx={{mr:2, ml:1}}>I want to compress an image</Button>
        <Button onClick={() => navigate('/image-editor')} variant="outlined" sx={{mr:1}}>I want to edit an image</Button>
      </div>

    </div>
  )
}

export default Homepage